import FooterButtons from 'components/inputs/Material/FooterButtons'
import Info from 'components/inputs/Material/Info'
import { FormFieldsContainer } from '../Shared/styles'

export default function Logic() {
  return (
    <>
      <FormFieldsContainer>
        <Info />
      </FormFieldsContainer>
      <FooterButtons />
    </>
  )
}
